<template>
  <div>
    <div class="d-block d-md-none pt-10 px-7">
      <div class="d-flex align-center mb-8">
        <v-avatar size="70px">
          <v-img
            :src="getMedia(user)"
            :alt="user.name"
            lazy-src="/placeholder.jpg"
          />
        </v-avatar>
        <v-list-item color="primary">
          <v-list-item-content>
            <v-list-item-title
              class="title font-weight-bold letter-spacing-compact"
            >
              {{ user.full_name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ user.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </div>
      <div v-if="user.isTourismOperator()">
        <div class="d-flex justify-space-between font-weight-bold mb-7  title">
          <span class>Total Balance</span>
          <router-link
            :to="{ name: 'payments' }"
            class="font-weight-bold subtitle-1"
          >
            All Payments
            <v-icon color="primary" size="16px">$next</v-icon>
          </router-link>
        </div>
        <div class="d-flex flex-column pb-12 mb-0">
          <v-btn
            :disabled="!user.hasBalance()"
            depressed
            medium
            color="amber accent-2 subtitle-1"
            class="elevation-0 font-weight-bold mb-4"
            height="50px"
            @click="makePayment()"
          >
            New Payout
          </v-btn>
        </div>
      </div>
    </div>
    <div v-if="currentUser.isTourist()" class="mb-8 px-5">
      <div class="mb-4">
        <Weather />
      </div>
    </div>
    <v-row
      justify="space-between"
      class="content-area-row px-8"
      :class="{ 'align-stretch': currentUser.isAdmin() }"
    >
      <v-col
        cols="12"
        md="12"
        :lg="rightDrawer.opened ? 12 : 6"
        :xl="currentUser.isAdmin() ? 5 : 6"
        v-if="currentUser.isTourismOperator() || currentUser.isAdmin()"
      >
        <TodayGroup v-if="currentUser.isTourismOperator()" />
        <v-row class="pa-0 ma-0" v-if="currentUser.isAdmin()">
          <v-col class="pa-0 ma-0" sm="12">
            <OperatorActivity />
          </v-col>
          <v-col sm="12" class="pa-0 ma-0 mt-12">
            <SightingEntries />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        md="12"
        :lg="rightDrawer.opened ? 12 : 6"
        :xl="currentUser.isAdmin() ? 6 : 5"
      >
        <SpeciesTabList />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DashboardMain',
  metaInfo: {
    titleTemplate: '%s - Dashboard',
  },
  components: {
    TodayGroup: () => import('@components/TodayGroups'),
    SpeciesTabList: () => import('@components/SpeciesTabList'),
    Weather: () => import('@components/utilities/Weather'),
    OperatorActivity: () => import('@components/OperatorActivity'),
    SightingEntries: () => import('@components/SightingEntries'),
  },
  computed: {
    ...mapState('auth', {
      user: 'user',
    }),
  },
  methods: {
    async makePayment() {
      this.$bus.$emit('MAKE_PAYMENT');
    },
  },
};
</script>
